import { Button, Dialog } from '@mui/material';
import React from 'react';

type Props = {
  onClose: () => void;
  context: string;
};

/**
 * Simple dialog to test the framework without dependency on real dialogs required inputs
 */
const EchoDlg: React.FC<Props> = ({ onClose, context }: Props) => (
  <Dialog open={true} onClose={onClose}>
    {context}
    <Button size="large" onClick={onClose}>
      Close
    </Button>
  </Dialog>
);

export { EchoDlg };
